import React, { FC } from 'react'
import styles from './Centered.module.scss'
import { CenteredProps } from './Centered.model'

export const Centered: FC<CenteredProps> = (props) => {
  return <div className={styles.container}>{props.children}</div>
}
